// @ts-nocheck

// App
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useYieldCallback } from '@zillow/yield-callback';

// Components
import Button from 'app/shared/core/Button';
import Center from 'app/shared/modules/Center';
import Container from 'app/shared/core/Container';
import Row from 'app/shared/core/Row';

import AreaInformationWrapper from 'app/shared/modules/MobileSRP/AreaInformationWrapper';

// Lodash
import assign from 'lodash/assign';
import isEmpty from 'lodash/isEmpty';

// Misc / Utils
import controller from './controller';
import IconArrowFilled from 'images/icons/arrow-filled-white.svg';
import queryUtils from 'app/shared/utils/queryUtils';
import routeUtils from 'app/shared/utils/routeUtils';
import './style.scss';
import { emitTrackNextClickExplorePageEvent } from 'app/shared/models/Clickstream/ListingsClickstreamEvents';

const { object } = PropTypes;
const propTypes = {
  areaStore: object.isRequired,
};

const ExploreWrapper = ({ areaStore, dispatch, query, pathname, maxPage }) => {
  const { area, facts } = areaStore;
  const newQuery = assign({}, query, { page: 2 });
  const nextPageLink = pathname + queryUtils.stringify(newQuery);

  const hasFacts = controller.hasAreaFacts(facts);
  const hasListings = controller.hasAreaListings(facts);
  const hasData = hasFacts && hasListings;

  const yieldTrackingAndTransitionTo = useYieldCallback(() => {
    emitTrackNextClickExplorePageEvent();
    window.router.transitionTo(nextPageLink);
  });

  if (isEmpty(area) || !hasData) {
    return null;
  }

  const handleButtonClick = (e) => {
    // Prevent the browser from going through with its default <a> behavior
    e.preventDefault();

    yieldTrackingAndTransitionTo();
  };

  return (
    <div className="ExploreWrapper">
      <Container>
        <AreaInformationWrapper />
        {maxPage > 1 && !routeUtils.isNearMeUrl(pathname) && (
          <Row size="md">
            <Center className="NextPageButton-container">
              <Button htmlTag="a" href={nextPageLink} btnType="primary" onClick={handleButtonClick}>
                Next page of search results{' '}
                <img
                  src={IconArrowFilled}
                  className="ExploreWrapper-arrow"
                  height="12px"
                  width="12px"
                  loading="lazy"
                  alt=""
                />
              </Button>
            </Center>
          </Row>
        )}
      </Container>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    areaStore: state.area,
    query: queryUtils.parse(ownProps.location.search),
    searchSlug: state.filter.search.slug,
    pathname: ownProps.location.pathname,
    totalListings: state.listings.totalListings,
  };
};

ExploreWrapper.propTypes = propTypes;
export default withRouter(connect(mapStateToProps)(ExploreWrapper));
